import { Auth0ContextInterface, useAuth0, User } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import { Flex, Paragraph } from 'theme-ui';
import { setToken, setUser } from '@/state/auth/index';
import { useAppDispatch, useAppSelector } from '@/hooks/store';

interface AdminUserLoginCheckerProps {
  children: JSX.Element;
}

const AdminUserLoginChecker = ({ children }: AdminUserLoginCheckerProps) => {
  const isAdmin = useAppSelector(state => state.auth.isAdmin);
  const dispatch = useAppDispatch();
  const [tokenLoading, setTokenLoading] = useState(true);
  const {
    user,
    isAuthenticated,
    isLoading,
    loginWithRedirect,
    getAccessTokenSilently,
  }: Auth0ContextInterface<User> = useAuth0();

  useEffect(() => {
    if (isAuthenticated) {
      getAccessTokenSilently()
        .then(t => {
          dispatch(setToken(t));
          user && dispatch(setUser(user));
        })
        .catch(console.error)
        .finally(() => setTokenLoading(false));
    }
  }, [isAuthenticated, getAccessTokenSilently, dispatch, user?.sub]);

  if (isLoading || (isAuthenticated && tokenLoading)) {
    return null;
  }

  if (!isAuthenticated) {
    const currentPath = window.location.pathname + window.location.search;
    loginWithRedirect({
      appState: { returnTo: currentPath },
    }).catch(console.error);
    return null;
  }

  if (!isAdmin) {
    // dont log them out,  just send show forbidden
    return (
      <Flex
        as="main"
        sx={{
          width: '100%',
          height: '100%',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <Paragraph>Forbidden</Paragraph>
      </Flex>
    );
  }

  return children;
};

export default AdminUserLoginChecker;
